import { render, staticRenderFns } from "./SupportAccess.vue?vue&type=template&id=c6432d6e&scoped=true"
import script from "./SupportAccess.vue?vue&type=script&lang=js"
export * from "./SupportAccess.vue?vue&type=script&lang=js"
import style0 from "./SupportAccess.vue?vue&type=style&index=0&id=c6432d6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6432d6e",
  null
  
)

export default component.exports